import React, { Component } from "react";

class ActiveCampaignForm extends Component {

    componentDidMount() {
      const script = document.createElement('script');
      script.src = `https://bossiet.activehosted.com/f/embed.php?id=${this.props.embedId}`;
      script.async = true;
      document.body.appendChild(script);
    }
  
    render() {
        return (
            <div className={this.props.embedClass}></div>
        );
    }
}

export default ActiveCampaignForm;



  


// WEBPACK FOOTER //
// ./src/modals/activeCompaign.js